module.exports = __webpack_public_path__ + "img/MapThumb_Tundra.55077a4f.webp";